module.exports = __webpack_public_path__ + "img/self-help-07.402ea8e2.png";